// filtersGoal.js
export default {
  2: [
    {
      category_id: 12000,
      category_name: 'Gol',
      category_color: '#00FF00',
      st: 'st1g',
      translationKey: 'goal.goal',
      generalName: 'Goles',
      singleName: 'Gol',
    },
    {
      category_id: 59800,
      category_name: 'Poste',
      category_color: '#FFFF00',
      st: 'st1y',
      translationKey: 'goal.goal_post',
      generalName: 'Remates al poste',
      singleName: 'Remate al poste',
    },
    {
      category_id: 53800,
      category_name: 'Fuera',
      category_color: '#DADADA',
      st: 'st1r',
      translationKey: 'goal.missed',
      generalName: 'Remates desviados',
      singleName: 'Remate desviado',
    },
    {
      category_id: 60000,
      category_name: 'Parado por el portero',
      category_color: '#00B8FF',
      st: 'st1b',
      translationKey: 'goal.saved_by_goalkeeper',
      generalName: 'Atajadas de portero',
      singleName: 'Atajada',
    },
  ],
  3: [
    {
      category_id: 12000,
      category_name: 'Gol Recibido',
      category_color: '#FF0000',
      st: 'st1r',
      translationKey: 'goal.goal_received',
      generalName: 'Goles recibidos',
      singleName: 'Gol recibido',
    },
    {
      category_id: 59800,
      category_name: 'Poste',
      category_color: '#FFFF00',
      st: 'st1y',
      translationKey: 'goal.goal_post',
      generalName: 'Remates al poste',
      singleName: 'Remate al poste',
    },
    {
      category_id: 53800,
      category_name: 'Fuera',
      category_color: '#DADADA',
      st: 'st1b',
      translationKey: 'goal.missed',
      generalName: 'Remates desviados',
      singleName: 'Remate desviado',
    },
    {
      category_id: 60000,
      category_name: 'Parado por el portero',
      category_color: '#00B8FF',
      st: 'st1g',
      translationKey: 'goal.saved_by_goalkeeper',
      generalName: 'Atajadas de portero',
      singleName: 'Atajada',
    },
  ],
};
